/*jshint esversion: 11 */
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner
} from 'reactstrap';

const PublishCircularModal = ({
  modalOpenState,
  closeModalHandler,
  publishHandler,
  selectedCount,
  loading
}) => {
  return (
    <Modal isOpen={modalOpenState} backdrop="static">
      <ModalHeader toggle={closeModalHandler}>Confirm Publish</ModalHeader>

      <ModalBody>
        {selectedCount === 1
          ? 'Are you sure you want to publish this circular?'
          : `Are you sure you want to publish ${selectedCount} circular(s)?`}
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={closeModalHandler}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button color="success" onClick={publishHandler} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Publishing...
            </>
          ) : (
            'Publish'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PublishCircularModal;
